import { useEffect, useState } from 'react';
import Transform from '../../components/TransForm/Transform';
import StyledTable from '../../components/table-component/StyledTable';
import { useDispatch, useSelector } from 'react-redux';
import Vehicule from '../../data/schemas/vehicule';
import { createVehicule, deleteVehicule, fetchVehicules, updateVehicule } from '../../data/slices/vehiculeSlice';
import { notify } from '../../settings/toastSetting';
import { Dialog, Box, Paper, Typography } from '@mui/material';
import { Add, TimeToLeave } from '@mui/icons-material';
import { output, sortByProp, COLORS } from '../../settings/themeSettings';
import PageHeader from '../../components/layout/PageHeader';

const VehiculePage = (props) => {
    const { vehicules } = useSelector((state) => state.vehicules);
    const dispatch = useDispatch();

    const [vehicule, setVehicule] = useState(null); 
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
        setVehicule(null);
    }

    const addVehicule = (data, cb) => {
        setOpen(false);
        if (data.id) {
            updateVehicule(data, (err) => output(err), (resp) => {
                cb();
                notify("Le véhicule a été enregistré avec succès !");
                dispatch(fetchVehicules());
            });
            return;
        }

        createVehicule(data, (err) => output(err), (resp) => {
            notify("Le véhicule a été ajouté avec succès !");
            dispatch(fetchVehicules());
            cb();
        });
    }

    const onVehiculeChanged = (id) => {
        setVehicule(vehicules.find((v) => v.id === id));
        setOpen(true);
    }

    const onDelete = (id) => {
        setOpen(false);
        deleteVehicule(id, (err) => output(err), (resp) => {
            setVehicule(null);
            notify("Le véhicule a bien été supprimé !");
            dispatch(fetchVehicules());
        })
    }

    useEffect(() => {
        dispatch(fetchVehicules());
    }, [dispatch]);

    return (
        <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: '#f8fafc', minHeight: '100vh' }}>
            <PageHeader 
                title="Gestion de la Flotte"
                subtitle="Suivez et gérez les véhicules de votre parc automobile"
                icon={TimeToLeave}
                breadcrumbs={[
                    { label: 'Paramètres', path: '/parametres' },
                    { label: 'Véhicules', path: '/parametres/vehicules' }
                ]}
                actions={[
                    { 
                        label: 'Ajouter un véhicule', 
                        icon: <Add />, 
                        onClick: () => { setVehicule(null); setOpen(true); },
                        color: 'primary'
                    }
                ]}
            />

            <Paper elevation={0} sx={{ 
                borderRadius: '16px', 
                overflow: 'hidden', 
                border: '1px solid',
                borderColor: COLORS.gray[200],
                bgcolor: 'white'
            }}>
                <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: COLORS.gray[100], bgcolor: COLORS.gray[50] }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: COLORS.secondary, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        Liste des véhicules ({vehicules.length})
                    </Typography>
                </Box>
                
                <StyledTable  
                    rows={[...vehicules].sort((a,b) => sortByProp(a, b, 'modele'))} 
                    head={Object.keys(new Vehicule())} 
                    onOptionClicked={onVehiculeChanged}
                />
            </Paper>

            <Dialog 
                open={open} 
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: { borderRadius: '20px', p: 1 }
                }}
            >
                <Transform 
                    onSubmit={addVehicule} 
                    mandatories={["modele", "marque", "matricule"]} 
                    entity={new Vehicule()} 
                    toUpdate={vehicule} 
                    onDelete={onDelete}
                    onCancel={handleClose}
                />
            </Dialog>
        </Box>
    );
}

export default VehiculePage;
